import { useCallback, useEffect, useRef, useState } from 'react';

export type UseElementInViewProps = {
  disabled?: boolean;
  initialViewState?: boolean | null;
  options: IntersectionObserverInit;
};

export const useElementInView = ({
  disabled = false,
  initialViewState = false,
  options
}: UseElementInViewProps) => {
  const elementRef = useRef(null);
  const [ inView, setInView ] = useState(initialViewState);

  const callback = useCallback((entries: IntersectionObserverEntry[]) => {
    const [ entry ] = entries;

    setInView(entry.isIntersecting);
  }, []);

  useEffect(() => {
    if (disabled) return;

    const observer = new IntersectionObserver(callback, options);

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    const current = elementRef.current;

    return () => {
      if (current) {
        observer.unobserve(current);
      }
    };
  }, [ callback, disabled, options ]);

  return { elementRef, inView };
};
